import { combineReducers } from 'redux';

import env from './env';
import catalog from './catalog';
import profile from './profile';
import accounts from './accounts';
import features from './features';

const reducers = combineReducers( {
	env,
	catalog,
	profile,
	accounts,
	features,
});

export type AppState = ReturnType<typeof reducers>;

export default reducers;
